import { j as a } from "./jsx-runtime-3tyXYecC.mjs";
import u, { useRef as h, useLayoutEffect as H, isValidElement as M, useState as R, useEffect as b, useCallback as W } from "react";
import { createPortal as _ } from "react-dom";
import { d as A } from "./index-DH8DM7A9.mjs";
import { f as o } from "./index-LyFokDcn.mjs";
import { m as w } from "./tss-DN0acMKN.mjs";
import { T as O } from "./Transition-4HZvpgGj.mjs";
import { I as Z } from "./icon-v2-DGtVEk7e.mjs";
import { M as D, d as V } from "./constants-CnFYFetN.mjs";
import { B as U } from "./button-CUHBhgeQ.mjs";
import { I as P } from "./icon-button-BxDvkq_l.mjs";
import { I as G } from "./X14x14-Dq3_cvuT.mjs";
const k = (e) => u.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 20 20", width: "20", height: "20" }, e),
  u.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    u.createElement("path", { fillRule: "nonzero", d: "M10,20 C4.47715248,20 0,15.5228476 0,10 C0,4.47715238 4.47715248,0 10,0 C15.5228475,0 20,4.47715238 20,10 C20,15.5228476 15.5228475,20 10,20 Z M15.0418983,6.70501905 C15.3992073,6.13048571 15.254887,5.35486476 14.7195054,4.97267524 C14.181796,4.58798667 13.4613586,4.74535905 13.1052134,5.31864381 L9.09567057,11.7734067 L6.57239371,9.96862095 C6.03468438,9.58393333 5.31308305,9.74130571 4.95810171,10.3145905 C4.60079267,10.8891238 4.74511295,11.6647448 5.28049457,12.0469343 L9.74045629,15.2380952 L15.0418983,6.70501905 Z" })
  )
);
k.displayName = "CheckCircle20x20";
const I = (e) => u.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 21 21", width: "21", height: "21" }, e),
  u.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    u.createElement("path", { fillRule: "nonzero", d: "M10.5,0 C4.70073333,0 0,4.7012 0,10.5 C0,16.2992667 4.70073333,21 10.5,21 C16.2988,21 21,16.2992667 21,10.5 C21,4.7012 16.2988,0 10.5,0 Z M9,5.23889268 C9,4.55573435 9.67288732,4 10.5,4 C11.3271127,4 12,4.55573435 12,5.23889268 L12,10.7611073 C12,11.4442656 11.3271127,12 10.5,12 C9.67288732,12 9,11.4442656 9,10.7611073 L9,5.23889268 Z M10.5,16 C9.67314815,16 9,15.3271872 9,14.5004629 C9,13.6728128 9.67314815,13 10.5,13 C11.3273148,13 12,13.6728128 12,14.5004629 C12,15.3271872 11.3273148,16 10.5,16 Z" })
  )
);
I.displayName = "ExclamationCircle21x21";
const E = (e) => u.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 21 21", width: "21", height: "21" }, e),
  u.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    u.createElement("path", { d: "M10.5,0 C16.29899,0 21,4.70101 21,10.5 C21,16.29899 16.29899,21 10.5,21 C4.70101,21 0,16.29899 0,10.5 C0,4.70101 4.70101,0 10.5,0 Z M10.5,9 C9.948,9 9.5,9.448 9.5,10 L9.5,10 L9.5,16 L9.50673178,16.1165685 C9.56453061,16.6137143 9.98742857,17 10.5,17 C11.052,17 11.5,16.552 11.5,16 L11.5,16 L11.5,10 L11.4932682,9.88343149 C11.4354694,9.38628571 11.0125714,9 10.5,9 Z M10.5,4 C9.672,4 9,4.672 9,5.5 C9,6.328 9.672,7 10.5,7 C11.328,7 12,6.328 12,5.5 C12,4.672 11.328,4 10.5,4 Z" })
  )
);
E.displayName = "InfoCircle21x21";
var i = /* @__PURE__ */ ((e) => (e.discovery = "discovery", e.error = "error", e.info = "info", e.success = "success", e.warning = "warning", e))(i || {});
const C = 500, S = 68, T = 5e3, L = 1e4, Q = w()(() => ({
  default: {
    opacity: 0,
    pointerEvents: "none",
    transform: `translate(0, -${S.toString()}px)`,
    transition: `
			transform ${C.toString()}ms cubic-bezier(0.29, 0, 0.4, 1),
			opacity ${C.toString()}ms ease-in-out
		`,
    visibility: "hidden"
  },
  entering: {
    opacity: 0,
    transform: `translate(0, -${S.toString()}px)`,
    visibility: "visible"
  },
  entered: {
    opacity: o.ifFeature("encore", 1, 0.92),
    transform: "translate(0, 0)",
    visibility: "visible"
  },
  exiting: {
    visibility: "visible"
  },
  exited: {
    visibility: "hidden"
  }
})), q = (e) => {
  const { children: s, show: d, timeout: c = C, ...n } = e, { classes: t, cx: r } = Q(), x = [n["data-fabric-component"], "SlidedownTransition"].filter(Boolean).join(" ");
  return /* @__PURE__ */ a.jsx(O, { in: d, timeout: c, ...n, children: (l) => /* @__PURE__ */ a.jsx("div", { className: r(t.default, t[l]), "data-fabric-component": x, children: s }) });
}, N = w()(({ borderRadiuses: e, constructs: s, mixins: d, mode: c, palette: n, spacing: t, typography: r }) => ({
  slidedown: {
    alignItems: o.ifFeature("encore", "flex-start", "center"),
    borderRadius: o.ifFeature("encore", e[300], "0 0 3px 3px"),
    boxShadow: o.ifFeature(
      "encore",
      `3px 3px 10px 2px ${d.alpha(s.surface.neutral.xxStrong, 0.1)}`,
      "0 2px 5px 0 rgba(0, 0, 0, 0.25)"
    ),
    boxSizing: "border-box",
    color: s.text.neutral.forcedWhite,
    display: "flex",
    minHeight: t(6),
    margin: "0 auto",
    outline: c === D.Dye ? `2px solid ${V.main}` : void 0,
    padding: o.ifFeature("encore", t(1.5, 2), t(0, 2)),
    pointerEvents: "all",
    textAlign: "left",
    maxWidth: "832px"
  },
  action: {
    marginLeft: t(6),
    paddingRight: t(1.5),
    position: "relative"
  },
  actionLink: {
    color: n.common.white,
    fontSize: r.small.fontSize,
    lineHeight: r.teenie.lineHeight,
    fontWeight: r.fontWeightHeavy,
    "&:hover": {
      color: n.common.white
    }
  },
  // @startCleanup encore
  divider: {
    position: "relative",
    margin: "0 8px 0 0",
    "&:after": {
      display: "block",
      backgroundColor: "rgba(255, 255, 255, 0.6)",
      position: "absolute",
      content: '""',
      height: t(2.5),
      pointerEvents: "none",
      width: "1px",
      top: "50%",
      marginTop: "-10px"
    }
  },
  // @endCleanup encore
  icon: {
    alignItems: "center",
    display: "flex",
    fill: "currentColor",
    marginTop: o.ifFeature("encore", t(1)),
    marginRight: t(o.ifFeature("encore", 1.5, 1))
  },
  text: {
    flex: "1",
    fontSize: r.large.fontSize,
    fontWeight: r.fontWeightSemibold,
    lineHeight: o.ifFeature("encore", r.large.lineHeight, r.medium.lineHeight),
    marginTop: o.ifFeature("encore", t(0.5)),
    // @startCleanup encore
    paddingTop: o.ifFeature("encore", void 0, "13px"),
    paddingBottom: o.ifFeature("encore", void 0, "13px")
    // @endCleanup encore
  },
  description: {
    fontSize: r.small.fontSize,
    fontWeight: r.fontWeightRegular,
    lineHeight: r.small.lineHeight
  },
  discovery: {
    backgroundColor: o.ifFeature("encore", s.surface.discovery.strong, n.discovery.main)
  },
  error: {
    backgroundColor: o.ifFeature("encore", s.surface.error.strong, n.error.main)
  },
  info: {
    backgroundColor: o.ifFeature("encore", s.surface.info.strong, n.info.main)
  },
  success: {
    backgroundColor: o.ifFeature("encore", s.surface.success.strong, n.success.main)
  },
  warning: {
    backgroundColor: o.ifFeature("encore", s.surface.warning.strong, n.warning.main)
  }
})), J = ({ biId: e, children: s, text: d, url: c }) => {
  const { classes: n } = N();
  return s || d && c ? /* @__PURE__ */ a.jsx("span", { className: n.action, children: s || o.ifFeature(
    "encore",
    /* @__PURE__ */ a.jsx(U, { dark: !0, "data-bi-id": e, href: c, size: "small", type: "button", variant: "outlined", children: d }),
    /* @__PURE__ */ a.jsx("a", { className: n.actionLink, "data-bi-id": e, href: c, children: d })
  ) }) : null;
}, ge = (e) => {
  const { visible: s } = e.state, { action: d } = e.props, c = e.props.type || e.state.type || i.info, n = d ? L : T;
  s && c === i.success ? e.runAutoClose = window.setTimeout(() => e._handleVisible(), n) : clearTimeout(e.runAutoClose);
}, K = ({
  _handleVisible: e,
  timeoutIdRef: s,
  type: d = i.info,
  visible: c,
  action: n
}) => {
  const t = n ? L : T;
  c && d === i.success ? s.current = window.setTimeout(() => e(), t) : clearTimeout(s.current);
}, X = (e) => {
  switch (e) {
    case i.error:
      return /* @__PURE__ */ a.jsx(I, {});
    case i.success:
      return /* @__PURE__ */ a.jsx(k, {});
    default:
      return /* @__PURE__ */ a.jsx(E, {});
  }
};
function Y({
  action: e,
  description: s,
  message: d,
  onDismiss: c,
  showDismiss: n,
  show: t,
  type: r = i.info,
  ...x
}) {
  const { classes: l, cx: p } = N(), m = h(null), f = h(null), g = {
    [i.discovery]: "gift-solid",
    [i.info]: "circle-info-solid",
    [i.success]: "circle-check-solid",
    [i.error]: "circle-exclamation-solid",
    [i.warning]: "triangle-exclamation-solid"
  }, v = {
    [i.discovery]: "status",
    [i.info]: "status",
    [i.success]: "status",
    [i.error]: "alert",
    [i.warning]: "alert"
  }, y = [x["data-fabric-component"], "SimpleSlidedown"].filter(Boolean).join(" "), B = e && n && /* @__PURE__ */ a.jsx("span", { className: l.divider }), z = n === !1 ? null : /* @__PURE__ */ a.jsx(
    P,
    {
      "aria-label": window.jQuery ? $.__("Dismiss slidedown") : "Dismiss slidedown",
      dark: !0,
      floatingIcon: o.ifFeature("encore", !1, !0),
      icon: o.ifFeature("encore", "xmark-solid", /* @__PURE__ */ a.jsx(G, { "aria-hidden": "true" })),
      noBoundingBox: o.ifFeature("encore", !1, !0),
      onClick: c || Function.prototype,
      ref: m,
      size: o.ifFeature("encore", "small"),
      type: "button",
      variant: o.ifFeature("encore", "outlined")
    }
  );
  return H(() => {
    var F;
    n && m.current && (t ? (f.current = document.activeElement, window.setTimeout(() => {
      var j;
      (j = m.current) == null || j.focus();
    }, 0)) : (F = f.current) == null || F.focus());
  }, [t, n]), /* @__PURE__ */ a.jsxs(
    "div",
    {
      "aria-hidden": !t,
      className: p(l.slidedown, {
        [l.discovery]: r === i.discovery,
        [l.error]: r === i.error,
        [l.info]: r === i.info,
        [l.success]: r === i.success,
        [l.warning]: r === i.warning
      }),
      "data-fabric-component": y,
      role: v[r],
      children: [
        /* @__PURE__ */ a.jsx("span", { className: l.icon, children: o.ifFeature("encore", /* @__PURE__ */ a.jsx(Z, { name: g[r], size: 16 }), X(r)) }),
        /* @__PURE__ */ a.jsxs("div", { className: l.text, children: [
          d,
          s ? /* @__PURE__ */ a.jsx("div", { className: l.description, children: s }) : null
        ] }),
        /* @__PURE__ */ a.jsx(J, { ...M(e) ? { children: e } : e }),
        o.ifFeature("encore", null, B),
        z
      ]
    }
  );
}
const ee = (e) => (d) => {
  const [c, n] = R(!1), { show: t } = d;
  return b(() => {
    t ? n(!0) : setTimeout(() => n(!1), C);
  }, [t, c]), c ? /* @__PURE__ */ a.jsx(e, { ...d }) : null;
}, ne = w()(() => ({
  slidedownPortal: {
    height: 0,
    pointerEvents: "none",
    position: "fixed",
    top: o.ifFeature("encore", 40, 0),
    width: "100%"
  }
}));
function te({ action: e, description: s, message: d, onDismiss: c, show: n, type: t }) {
  const [r, x] = R(n), l = h(document.createElement("div")), p = h(0), { classes: m } = ne(), f = h(c);
  f.current = c;
  const g = W(() => {
    f.current && typeof f.current == "function" && f.current(), x(!1);
  }, [f]);
  return b(() => {
    l.current.className = m.slidedownPortal, l.current.style.zIndex = String(A.getMaxZIndex() + 10), l.current.dataset.fabricComponent = "SlidedownPortal", document.body.appendChild(l.current);
    const v = l.current;
    return () => {
      document.body.removeChild(v);
    };
  }, [m.slidedownPortal]), b(() => {
    K({
      action: e,
      _handleVisible: g,
      timeoutIdRef: p,
      type: t,
      visible: r
    });
  }, [g, p, t, r]), _(
    /* @__PURE__ */ a.jsx(q, { appear: !0, show: r, children: /* @__PURE__ */ a.jsx(
      Y,
      {
        action: e,
        description: s,
        message: d,
        onDismiss: g,
        show: !0,
        showDismiss: t !== i.success,
        type: t
      }
    ) }),
    l.current
  );
}
const he = ee(te);
export {
  C as D,
  he as S,
  i as T,
  q as a,
  Y as b,
  ge as c
};
//# sourceMappingURL=index-CoZFka0j.mjs.map
